module.exports = __webpack_public_path__ + "static/img/icon_cyber.8cf663d1.png";